import React from "react";
import { Button, Form, Icon, Input} from "semantic-ui-react";
import shop from "shop/shop"
import { observer } from "mobx-react";

function CouponInput({ label, defaultValue="", defaultActive= false}) {
  const [active, setActive] = React.useState( defaultActive )
  const [couponCode, setCouponCode] = React.useState( defaultValue )
  const { activeCoupons } = shop.cart
  const hasCoupons = activeCoupons.length > 0

  return <React.Fragment><Form
    onSubmit={
      async () => {
        await shop.cart.postCoupons( couponCode )
      }
    }
    className={"CouponInput"}>
    {!hasCoupons && <div>
      {!active && <Button style={{borderRadius: "35px", height: "50px"}} basic fluid onClick={() => {
        setActive( true )
      }
      }>
        <div className="flex flex-row justify-between">
          <div>Coupons</div>
          <div><Icon name={"question circle outline"}/></div>
        </div>
      </Button>
      }
      {active && <React.Fragment>
        {label &&  <label>{label}</label>}
        <div className="pb1">
          <Input style={{backgroundColor: "#ffffff"}}
            value={couponCode}
            onChange={( e ) => {
              setCouponCode( e.currentTarget.value )
              
            }
            } size={"small"} fluid/>
        </div>
        <Button style={{borderRadius: "35px", height: "50px", width: "100%"}}
          type={"submit"}
          fluid size={"small"} primary>{translate("Aktivieren")}</Button>
      </React.Fragment>}
    </div>}
    
    <div className="activeCoupons pt2">
      {activeCoupons
        .map( ( code, index ) => {
          return <div key={`${index}-${code}`} className="br4 pa1 ph3 ba b--black-10 f6 tc mb1 flex flex-row justify-between">
            {code}
            <Icon name={"check circle"}/>
          </div>
        } )}

    </div>
  </Form>
  {shop.cart.data.giftcards && shop.cart.data.giftcards[0] && shop.config.plugin.deleteCoupons && <Button style={{borderRadius: "35px", height: "50px"}} className="w-100" onClick={
        async () => {
          await shop.cart.postCoupons( "deleteCoupon" )
        }
      }>
        {translate("Code entfernen")}
        </Button>}
  </React.Fragment>
}


export default observer( CouponInput )


// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Cart/CouponInput.js